import React from 'react'

import { Field } from 'formik'

import { Form, Col, Row } from '_zari/core'

const FlagAprobacionOrdenCompraFormGroup = ({ iValue, fIsSubmitting, montoValue }) => {
  return (
    <>
      <Field name='flagAprobacionOrdenCompra'>
        {({ field }) => (
          <Form.Checkbox
            {...field}
            checked={iValue}
            disabled={fIsSubmitting}
            id='checkbox-flagAprobacionOrdenCompra'
            label='Aprobacion orden de compra'
          />
        )}
      </Field>
      {iValue && (
        <Row className='mt-2 ml-4'>
          <Col md={8}>
            <Field name='montoAprobacionOrdenCompra'>
              {({ field }) => (
                <Form.Group>
                  <Form.Label text='Monto límite aprobación OC' htmlFor='montoAprobacionOrdenCompra' md={8} />
                  <Col md={4}>
                    <Form.InputNumber
                      {...field}
                      id='montoAprobacionOrdenCompra'
                      disabled={fIsSubmitting}
                      value={montoValue || ''}
                      placeholder='Ej: 260'
                    />
                  </Col>
                </Form.Group>
              )}
            </Field>
          </Col>
        </Row>
      )}
    </>
  )
}

export default React.memo(FlagAprobacionOrdenCompraFormGroup)
